/**
 * Тема: пользовательский режим (system/light/dark) хранится в localStorage, эффективная
 * схема (light/dark) применяется как `data-theme` на <html>. Те же ключ и логика повторены
 * инлайн-скриптом в public/index.html — он ставит тему ДО загрузки бандла (без моргания).
 */
export type TThemeMode = 'system' | 'light' | 'dark';
export type TResolvedTheme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'moni-theme';

export function getStoredThemeMode(): TThemeMode {
  try {
    const value = localStorage.getItem(THEME_STORAGE_KEY);
    if (value === 'light' || value === 'dark' || value === 'system') {
      return value;
    }
  } catch {
    // localStorage недоступен — дефолтим на system
  }
  return 'system';
}

export function storeThemeMode(mode: TThemeMode): void {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, mode);
  } catch {
    // localStorage недоступен — режим не переживёт перезагрузку, но UI отработает
  }
}

export function getSystemTheme(): TResolvedTheme {
  return typeof window !== 'undefined' &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light';
}

/** Эффективная схема для режима: system → текущая системная, иначе сам режим. */
export function resolveTheme(mode: TThemeMode): TResolvedTheme {
  return mode === 'system' ? getSystemTheme() : mode;
}
